export const oracleDocument = {
    "formatVersion": 1,
    "oracleId": "everyday-health-official-2026-v2-profit-margin",
    "status": "human-reviewed-production-oracle",
    "reviewedOn": "2026-08-24",
    "policy": "İnsan tarafından gözden geçirilmiş literal registry oracle değerleridir; çalışma anında çekirdekten üretilmez. Config mutasyonları yalnız test yürütücüsündeki kapalı yol izin listesiyle uygulanır.",
    "publisherOracleRelationship": "Publisher resmî oracle kaydı ayrı bir dosya ve ayrı bir yayın kapısıdır; bu registry oracle veya contract receipt onun yerine geçmez.",
    "coreSourceSha256": {
        "packages/calculation-core/src/everyday.ts": "4dc31e8a31fa517ee8e1879813fd55a2907954c00083ff6299d170e941ae12ed",
        "packages/calculation-core/src/health-reference.ts": "c9c7a10a7b133c2056ce7411192f329ae99ec5db774fb9582bb8a9178574cffd"
    },
    "records": [
        {
            "canonicalToolId": "arac-emlak-yasam.lpg-donusum-amortisman-hesaplama",
            "runtimeToolId": "lpg-payback",
            "configVersion": "1.0.0",
            "cases": [
                {
                    "caseId": "positive-payback",
                    "scenario": "positive",
                    "input": {
                        "conversionCost": 25000,
                        "extraOneOffCost": 5000,
                        "gasolineConsumptionL100Km": 8,
                        "lpgConsumptionL100Km": 9.6,
                        "gasolinePricePerLitre": 50,
                        "lpgPricePerLitre": 25,
                        "monthlyDistanceKm": 1500
                    },
                    "expected": {
                        "ok": true,
                        "value": {
                            "conversionCost": 25000,
                            "extraOneOffCost": 5000,
                            "gasolineConsumptionL100Km": 8,
                            "lpgConsumptionL100Km": 9.6,
                            "gasolinePricePerLitre": 50,
                            "lpgPricePerLitre": 25,
                            "monthlyDistanceKm": 1500,
                            "gasolineCostPerKm": 4,
                            "lpgCostPerKm": 2.4,
                            "savingsPerKm": 1.6,
                            "savingsPer100Km": 160,
                            "investment": 30000,
                            "monthlySavings": 2400,
                            "annualSavings": 28800,
                            "paybackPossible": true,
                            "paybackDistanceKm": 18750,
                            "paybackMonths": 12.5
                        }
                    },
                    "tolerance": 1e-9
                },
                {
                    "caseId": "negative-saving-no-payback",
                    "scenario": "no-payback",
                    "input": {
                        "conversionCost": 20000,
                        "gasolineConsumptionL100Km": 7,
                        "lpgConsumptionL100Km": 10,
                        "gasolinePricePerLitre": 40,
                        "lpgPricePerLitre": 35,
                        "monthlyDistanceKm": 1000
                    },
                    "expected": {
                        "ok": true,
                        "value": {
                            "conversionCost": 20000,
                            "gasolineConsumptionL100Km": 7,
                            "lpgConsumptionL100Km": 10,
                            "gasolinePricePerLitre": 40,
                            "lpgPricePerLitre": 35,
                            "monthlyDistanceKm": 1000,
                            "extraOneOffCost": 0,
                            "gasolineCostPerKm": 2.8,
                            "lpgCostPerKm": 3.5,
                            "savingsPerKm": -0.7000000000000002,
                            "savingsPer100Km": -70.00000000000001,
                            "investment": 20000,
                            "monthlySavings": -700.0000000000002,
                            "annualSavings": -8400.000000000004,
                            "paybackPossible": false,
                            "paybackDistanceKm": null,
                            "paybackMonths": null
                        }
                    },
                    "tolerance": 1e-9
                },
                {
                    "caseId": "zero-saving-threshold",
                    "scenario": "threshold",
                    "input": {
                        "conversionCost": 15000,
                        "extraOneOffCost": 0,
                        "gasolineConsumptionL100Km": 10,
                        "lpgConsumptionL100Km": 20,
                        "gasolinePricePerLitre": 40,
                        "lpgPricePerLitre": 20,
                        "monthlyDistanceKm": 1000
                    },
                    "expected": {
                        "ok": true,
                        "value": {
                            "conversionCost": 15000,
                            "extraOneOffCost": 0,
                            "gasolineConsumptionL100Km": 10,
                            "lpgConsumptionL100Km": 20,
                            "gasolinePricePerLitre": 40,
                            "lpgPricePerLitre": 20,
                            "monthlyDistanceKm": 1000,
                            "gasolineCostPerKm": 4,
                            "lpgCostPerKm": 4,
                            "savingsPerKm": 0,
                            "savingsPer100Km": 0,
                            "investment": 15000,
                            "monthlySavings": 0,
                            "annualSavings": 0,
                            "paybackPossible": false,
                            "paybackDistanceKm": null,
                            "paybackMonths": null
                        }
                    },
                    "tolerance": 1e-9
                },
                {
                    "caseId": "zero-conversion-cost",
                    "scenario": "adversarial",
                    "input": {
                        "conversionCost": 0,
                        "gasolineConsumptionL100Km": 8,
                        "lpgConsumptionL100Km": 9.6,
                        "gasolinePricePerLitre": 50,
                        "lpgPricePerLitre": 25,
                        "monthlyDistanceKm": 1500
                    },
                    "expected": {
                        "ok": false,
                        "field": "conversionCost",
                        "errorCode": "OUT_OF_RANGE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "negative-extra-cost",
                    "scenario": "adversarial",
                    "input": {
                        "conversionCost": 25000,
                        "extraOneOffCost": -1,
                        "gasolineConsumptionL100Km": 8,
                        "lpgConsumptionL100Km": 9.6,
                        "gasolinePricePerLitre": 50,
                        "lpgPricePerLitre": 25,
                        "monthlyDistanceKm": 1500
                    },
                    "expected": {
                        "ok": false,
                        "field": "extraOneOffCost",
                        "errorCode": "OUT_OF_RANGE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "sub-stability-consumption",
                    "scenario": "adversarial",
                    "input": {
                        "conversionCost": 25000,
                        "gasolineConsumptionL100Km": 1e-12,
                        "lpgConsumptionL100Km": 9.6,
                        "gasolinePricePerLitre": 50,
                        "lpgPricePerLitre": 25,
                        "monthlyDistanceKm": 1500
                    },
                    "expected": {
                        "ok": false,
                        "field": "gasolineConsumptionL100Km",
                        "errorCode": "OUT_OF_RANGE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "numeric-string-distance",
                    "scenario": "adversarial",
                    "input": {
                        "conversionCost": 25000,
                        "gasolineConsumptionL100Km": 8,
                        "lpgConsumptionL100Km": 9.6,
                        "gasolinePricePerLitre": 50,
                        "lpgPricePerLitre": 25,
                        "monthlyDistanceKm": "1500"
                    },
                    "expected": {
                        "ok": false,
                        "field": "monthlyDistanceKm",
                        "errorCode": "NOT_FINITE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "missing-input-object",
                    "scenario": "adversarial",
                    "input": null,
                    "expected": {
                        "ok": false,
                        "field": "input",
                        "errorCode": "REQUIRED"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "invalid-config-limit",
                    "scenario": "adversarial",
                    "input": {
                        "conversionCost": 25000,
                        "gasolineConsumptionL100Km": 8,
                        "lpgConsumptionL100Km": 9.6,
                        "gasolinePricePerLitre": 50,
                        "lpgPricePerLitre": 25,
                        "monthlyDistanceKm": 1500
                    },
                    "configMutation": {
                        "path": [
                            "maxAbsoluteInput"
                        ],
                        "replacement": 0
                    },
                    "expected": {
                        "ok": false,
                        "field": "config.maxAbsoluteInput",
                        "errorCode": "INVALID_CONFIG"
                    },
                    "tolerance": 0
                }
            ]
        },
        {
            "canonicalToolId": "arac-emlak-yasam.yakit-tuketimi-hesaplama",
            "runtimeToolId": "fuel-consumption",
            "configVersion": "1.0.0",
            "cases": [
                {
                    "caseId": "round-trip-gasoline",
                    "scenario": "positive",
                    "input": {
                        "fuelType": "benzin",
                        "distanceKm": 400,
                        "consumptionL100Km": 7,
                        "pricePerLitre": 45,
                        "direction": "gidisDonus"
                    },
                    "expected": {
                        "ok": true,
                        "value": {
                            "fuelType": "benzin",
                            "distanceKm": 400,
                            "consumptionL100Km": 7,
                            "pricePerLitre": 45,
                            "direction": "gidisDonus",
                            "effectiveDistanceKm": 800,
                            "consumedLitres": 56,
                            "costPerKm": 3.15,
                            "costPer100Km": 315,
                            "totalCost": 2520
                        }
                    },
                    "tolerance": 1e-9
                },
                {
                    "caseId": "minimum-bounds",
                    "scenario": "boundary-lower",
                    "input": {
                        "fuelType": "lpg",
                        "distanceKm": 1,
                        "consumptionL100Km": 1,
                        "pricePerLitre": 1,
                        "direction": "tekYon"
                    },
                    "expected": {
                        "ok": true,
                        "value": {
                            "fuelType": "lpg",
                            "distanceKm": 1,
                            "consumptionL100Km": 1,
                            "pricePerLitre": 1,
                            "direction": "tekYon",
                            "effectiveDistanceKm": 1,
                            "consumedLitres": 0.01,
                            "costPerKm": 0.01,
                            "costPer100Km": 1,
                            "totalCost": 0.01
                        }
                    },
                    "tolerance": 1e-9
                },
                {
                    "caseId": "maximum-bounds-round-trip",
                    "scenario": "boundary-upper",
                    "input": {
                        "fuelType": "motorin",
                        "distanceKm": 20000,
                        "consumptionL100Km": 50,
                        "pricePerLitre": 500,
                        "direction": "gidisDonus"
                    },
                    "expected": {
                        "ok": true,
                        "value": {
                            "fuelType": "motorin",
                            "distanceKm": 20000,
                            "consumptionL100Km": 50,
                            "pricePerLitre": 500,
                            "direction": "gidisDonus",
                            "effectiveDistanceKm": 40000,
                            "consumedLitres": 20000,
                            "costPerKm": 250,
                            "costPer100Km": 25000,
                            "totalCost": 10000000
                        }
                    },
                    "tolerance": 1e-9
                },
                {
                    "caseId": "zero-distance",
                    "scenario": "adversarial",
                    "input": {
                        "fuelType": "benzin",
                        "distanceKm": 0,
                        "consumptionL100Km": 7,
                        "pricePerLitre": 45,
                        "direction": "tekYon"
                    },
                    "expected": {
                        "ok": false,
                        "field": "distanceKm",
                        "errorCode": "OUT_OF_RANGE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "distance-above-maximum",
                    "scenario": "adversarial",
                    "input": {
                        "fuelType": "benzin",
                        "distanceKm": 20001,
                        "consumptionL100Km": 7,
                        "pricePerLitre": 45,
                        "direction": "tekYon"
                    },
                    "expected": {
                        "ok": false,
                        "field": "distanceKm",
                        "errorCode": "OUT_OF_RANGE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "consumption-above-maximum",
                    "scenario": "adversarial",
                    "input": {
                        "fuelType": "benzin",
                        "distanceKm": 100,
                        "consumptionL100Km": 51,
                        "pricePerLitre": 45,
                        "direction": "tekYon"
                    },
                    "expected": {
                        "ok": false,
                        "field": "consumptionL100Km",
                        "errorCode": "OUT_OF_RANGE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "unsupported-fuel",
                    "scenario": "adversarial",
                    "input": {
                        "fuelType": "elektrik",
                        "distanceKm": 100,
                        "consumptionL100Km": 7,
                        "pricePerLitre": 45,
                        "direction": "tekYon"
                    },
                    "expected": {
                        "ok": false,
                        "field": "fuelType",
                        "errorCode": "UNSUPPORTED_VALUE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "unsupported-direction",
                    "scenario": "adversarial",
                    "input": {
                        "fuelType": "benzin",
                        "distanceKm": 100,
                        "consumptionL100Km": 7,
                        "pricePerLitre": 45,
                        "direction": "cift"
                    },
                    "expected": {
                        "ok": false,
                        "field": "direction",
                        "errorCode": "UNSUPPORTED_VALUE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "numeric-string-price",
                    "scenario": "adversarial",
                    "input": {
                        "fuelType": "benzin",
                        "distanceKm": 100,
                        "consumptionL100Km": 7,
                        "pricePerLitre": "45",
                        "direction": "tekYon"
                    },
                    "expected": {
                        "ok": false,
                        "field": "pricePerLitre",
                        "errorCode": "NOT_FINITE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "invalid-config-distance-range",
                    "scenario": "adversarial",
                    "input": {
                        "fuelType": "benzin",
                        "distanceKm": 100,
                        "consumptionL100Km": 7,
                        "pricePerLitre": 45,
                        "direction": "tekYon"
                    },
                    "configMutation": {
                        "path": [
                            "distanceKm"
                        ],
                        "replacement": [
                            0,
                            20000
                        ]
                    },
                    "expected": {
                        "ok": false,
                        "field": "config.distanceKm",
                        "errorCode": "INVALID_CONFIG"
                    },
                    "tolerance": 0
                }
            ]
        },
        {
            "canonicalToolId": "ticari-muhasebe.kar-marji-ve-satis-fiyati-hesaplama",
            "runtimeToolId": "profit-margin",
            "configVersion": "2.0.0",
            "cases": [
                {
                    "caseId": "target-thirty-percent-sale-margin",
                    "scenario": "positive",
                    "input": {
                        "mode": "targetSaleMargin",
                        "cost": 100,
                        "targetMarginPercent": 30
                    },
                    "expected": {
                        "ok": true,
                        "value": {
                            "mode": "targetSaleMargin",
                            "cost": 100,
                            "salePrice": 142.85714285714286,
                            "profit": 42.85714285714286,
                            "markupPercent": 42.85714285714286,
                            "marginPercent": 30.000000000000004,
                            "isLoss": false
                        }
                    },
                    "tolerance": 1e-9
                },
                {
                    "caseId": "thirty-percent-cost-markup",
                    "scenario": "positive",
                    "input": {
                        "mode": "costMarkup",
                        "cost": 100,
                        "markupPercent": 30
                    },
                    "expected": {
                        "ok": true,
                        "value": {
                            "mode": "costMarkup",
                            "cost": 100,
                            "salePrice": 130,
                            "profit": 30,
                            "markupPercent": 30,
                            "marginPercent": 23.076923076923077,
                            "isLoss": false
                        }
                    },
                    "tolerance": 1e-9
                },
                {
                    "caseId": "analyze-profitable-sale",
                    "scenario": "positive",
                    "input": {
                        "mode": "analyzeSale",
                        "cost": 100,
                        "salePrice": 130
                    },
                    "expected": {
                        "ok": true,
                        "value": {
                            "mode": "analyzeSale",
                            "cost": 100,
                            "salePrice": 130,
                            "profit": 30,
                            "markupPercent": 30,
                            "marginPercent": 23.076923076923077,
                            "isLoss": false
                        }
                    },
                    "tolerance": 1e-9
                },
                {
                    "caseId": "analyze-sale-below-cost",
                    "scenario": "loss",
                    "input": {
                        "mode": "analyzeSale",
                        "cost": 100,
                        "salePrice": 80
                    },
                    "expected": {
                        "ok": true,
                        "value": {
                            "mode": "analyzeSale",
                            "cost": 100,
                            "salePrice": 80,
                            "profit": -20,
                            "markupPercent": -20,
                            "marginPercent": -25,
                            "isLoss": true
                        }
                    },
                    "tolerance": 1e-9
                },
                {
                    "caseId": "zero-target-margin-break-even",
                    "scenario": "threshold",
                    "input": {
                        "mode": "targetSaleMargin",
                        "cost": 100,
                        "targetMarginPercent": 0
                    },
                    "expected": {
                        "ok": true,
                        "value": {
                            "mode": "targetSaleMargin",
                            "cost": 100,
                            "salePrice": 100,
                            "profit": 0,
                            "markupPercent": 0,
                            "marginPercent": 0,
                            "isLoss": false
                        }
                    },
                    "tolerance": 1e-9
                },
                {
                    "caseId": "zero-cost-markup-break-even",
                    "scenario": "threshold",
                    "input": {
                        "mode": "costMarkup",
                        "cost": 100,
                        "markupPercent": 0
                    },
                    "expected": {
                        "ok": true,
                        "value": {
                            "mode": "costMarkup",
                            "cost": 100,
                            "salePrice": 100,
                            "profit": 0,
                            "markupPercent": 0,
                            "marginPercent": 0,
                            "isLoss": false
                        }
                    },
                    "tolerance": 1e-9
                },
                {
                    "caseId": "target-margin-upper-bound",
                    "scenario": "boundary-upper",
                    "input": {
                        "mode": "targetSaleMargin",
                        "cost": 100,
                        "targetMarginPercent": 99.99
                    },
                    "expected": {
                        "ok": true,
                        "value": {
                            "mode": "targetSaleMargin",
                            "cost": 100,
                            "salePrice": 999999.9999989999,
                            "profit": 999899.9999989999,
                            "markupPercent": 999899.9999989999,
                            "marginPercent": 99.99,
                            "isLoss": false
                        }
                    },
                    "tolerance": 1e-7
                },
                {
                    "caseId": "target-margin-one-hundred",
                    "scenario": "adversarial",
                    "input": {
                        "mode": "targetSaleMargin",
                        "cost": 100,
                        "targetMarginPercent": 100
                    },
                    "expected": {
                        "ok": false,
                        "field": "targetMarginPercent",
                        "errorCode": "OUT_OF_RANGE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "zero-cost",
                    "scenario": "adversarial",
                    "input": {
                        "mode": "costMarkup",
                        "cost": 0,
                        "markupPercent": 30
                    },
                    "expected": {
                        "ok": false,
                        "field": "cost",
                        "errorCode": "OUT_OF_RANGE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "zero-sale-price",
                    "scenario": "adversarial",
                    "input": {
                        "mode": "analyzeSale",
                        "cost": 100,
                        "salePrice": 0
                    },
                    "expected": {
                        "ok": false,
                        "field": "salePrice",
                        "errorCode": "OUT_OF_RANGE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "unsupported-mode",
                    "scenario": "adversarial",
                    "input": {
                        "mode": "margin",
                        "cost": 100,
                        "targetMarginPercent": 30
                    },
                    "expected": {
                        "ok": false,
                        "field": "mode",
                        "errorCode": "UNSUPPORTED_VALUE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "numeric-string-cost",
                    "scenario": "adversarial",
                    "input": {
                        "mode": "costMarkup",
                        "cost": "100",
                        "markupPercent": 30
                    },
                    "expected": {
                        "ok": false,
                        "field": "cost",
                        "errorCode": "NOT_FINITE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "missing-input-object",
                    "scenario": "adversarial",
                    "input": null,
                    "expected": {
                        "ok": false,
                        "field": "input",
                        "errorCode": "REQUIRED"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "invalid-target-margin-config",
                    "scenario": "adversarial",
                    "input": {
                        "mode": "targetSaleMargin",
                        "cost": 100,
                        "targetMarginPercent": 30
                    },
                    "configMutation": {
                        "path": [
                            "targetMarginPercent"
                        ],
                        "replacement": [
                            0,
                            100
                        ]
                    },
                    "expected": {
                        "ok": false,
                        "field": "config.targetMarginPercent",
                        "errorCode": "INVALID_CONFIG"
                    },
                    "tolerance": 0
                }
            ]
        },
        {
            "canonicalToolId": "saglik-yasam.bazal-metabolizma-hesaplama",
            "runtimeToolId": "basal-metabolic-rate",
            "configVersion": "1.0.0",
            "cases": [
                {
                    "caseId": "male-mifflin-within-source-range",
                    "scenario": "positive",
                    "input": {
                        "sex": "erkek",
                        "formula": "mifflin",
                        "ageYears": 30,
                        "heightCm": 180,
                        "weightKg": 75
                    },
                    "expected": {
                        "ok": true,
                        "value": {
                            "sex": "erkek",
                            "formula": "mifflin",
                            "ageYears": 30,
                            "heightCm": 180,
                            "weightKg": 75,
                            "mifflinKcalPerDay": 1730,
                            "revisedHarrisBenedictKcalPerDay": 1786.647,
                            "selectedKcalPerDay": 1730,
                            "selectedKcalPerHour": 72.08333333333333,
                            "selectedSourceScope": "within-cited-age-range",
                            "selectedSourceScopeNote": "Seçilen yaş, Mifflin–St Jeor çalışmasında bildirilen 19–78 yaş aralığındadır."
                        }
                    },
                    "tolerance": 1e-9
                },
                {
                    "caseId": "female-harris-age-range-not-explicit",
                    "scenario": "positive",
                    "input": {
                        "sex": "kadin",
                        "formula": "harris",
                        "ageYears": 35,
                        "heightCm": 165,
                        "weightKg": 60
                    },
                    "expected": {
                        "ok": true,
                        "value": {
                            "sex": "kadin",
                            "formula": "harris",
                            "ageYears": 35,
                            "heightCm": 165,
                            "weightKg": 60,
                            "mifflinKcalPerDay": 1295.25,
                            "revisedHarrisBenedictKcalPerDay": 1362.0330000000001,
                            "selectedKcalPerDay": 1362.0330000000001,
                            "selectedKcalPerHour": 56.751375,
                            "selectedSourceScope": "cited-age-range-not-explicit",
                            "selectedSourceScopeNote": "Roza–Shizgal PubMed özetinde kesin alt ve üst yaş sınırı verilmediği için yaş kapsamı ayrıca doğrulanamamıştır."
                        }
                    },
                    "tolerance": 1e-9
                },
                {
                    "caseId": "mifflin-age-eighteen-extrapolation",
                    "scenario": "boundary-and-extrapolation",
                    "input": {
                        "sex": "erkek",
                        "formula": "mifflin",
                        "ageYears": 18,
                        "heightCm": 180,
                        "weightKg": 75
                    },
                    "expected": {
                        "ok": true,
                        "value": {
                            "sex": "erkek",
                            "formula": "mifflin",
                            "ageYears": 18,
                            "heightCm": 180,
                            "weightKg": 75,
                            "mifflinKcalPerDay": 1790,
                            "revisedHarrisBenedictKcalPerDay": 1854.771,
                            "selectedKcalPerDay": 1790,
                            "selectedKcalPerHour": 74.58333333333333,
                            "selectedSourceScope": "outside-cited-age-range",
                            "selectedSourceScopeNote": "Seçilen yaş, Mifflin–St Jeor çalışmasında bildirilen 19–78 yaş aralığının dışındadır; sonuç ekstrapolasyondur."
                        }
                    },
                    "tolerance": 1e-9
                },
                {
                    "caseId": "age-below-input-range",
                    "scenario": "adversarial",
                    "input": {
                        "sex": "erkek",
                        "formula": "mifflin",
                        "ageYears": 17,
                        "heightCm": 180,
                        "weightKg": 75
                    },
                    "expected": {
                        "ok": false,
                        "field": "ageYears",
                        "errorCode": "OUT_OF_RANGE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "age-above-input-range",
                    "scenario": "adversarial",
                    "input": {
                        "sex": "erkek",
                        "formula": "mifflin",
                        "ageYears": 101,
                        "heightCm": 180,
                        "weightKg": 75
                    },
                    "expected": {
                        "ok": false,
                        "field": "ageYears",
                        "errorCode": "OUT_OF_RANGE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "height-below-input-range",
                    "scenario": "adversarial",
                    "input": {
                        "sex": "erkek",
                        "formula": "mifflin",
                        "ageYears": 30,
                        "heightCm": 99,
                        "weightKg": 75
                    },
                    "expected": {
                        "ok": false,
                        "field": "heightCm",
                        "errorCode": "OUT_OF_RANGE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "weight-above-input-range",
                    "scenario": "adversarial",
                    "input": {
                        "sex": "erkek",
                        "formula": "mifflin",
                        "ageYears": 30,
                        "heightCm": 180,
                        "weightKg": 301
                    },
                    "expected": {
                        "ok": false,
                        "field": "weightKg",
                        "errorCode": "OUT_OF_RANGE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "unsupported-sex",
                    "scenario": "adversarial",
                    "input": {
                        "sex": "diger",
                        "formula": "mifflin",
                        "ageYears": 30,
                        "heightCm": 180,
                        "weightKg": 75
                    },
                    "expected": {
                        "ok": false,
                        "field": "sex",
                        "errorCode": "UNSUPPORTED_VALUE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "unsupported-formula",
                    "scenario": "adversarial",
                    "input": {
                        "sex": "erkek",
                        "formula": "owen",
                        "ageYears": 30,
                        "heightCm": 180,
                        "weightKg": 75
                    },
                    "expected": {
                        "ok": false,
                        "field": "formula",
                        "errorCode": "UNSUPPORTED_VALUE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "source-verification-date-mismatch",
                    "scenario": "adversarial",
                    "input": {
                        "sex": "erkek",
                        "formula": "mifflin",
                        "ageYears": 30,
                        "heightCm": 180,
                        "weightKg": 75
                    },
                    "configMutation": {
                        "path": [
                            "metadata",
                            "lastVerifiedAt"
                        ],
                        "replacement": "2026-08-19"
                    },
                    "expected": {
                        "ok": false,
                        "field": "config.metadata.lastVerifiedAt",
                        "errorCode": "INVALID_CONFIG"
                    },
                    "tolerance": 0
                }
            ]
        },
        {
            "canonicalToolId": "saglik-yasam.ideal-kilo-hesaplama",
            "runtimeToolId": "historical-ideal-weight-reference",
            "configVersion": "1.0.0",
            "cases": [
                {
                    "caseId": "male-within-reference-range",
                    "scenario": "positive",
                    "input": {
                        "sex": "erkek",
                        "heightCm": 180,
                        "currentWeightKg": 75
                    },
                    "expected": {
                        "ok": true,
                        "value": {
                            "sex": "erkek",
                            "heightCm": 180,
                            "currentWeightKg": 75,
                            "devineKg": 74.99212598425197,
                            "robinsonKg": 72.64566929133858,
                            "hamwiKg": 77.33858267716536,
                            "referenceMinimumKg": 72.64566929133858,
                            "referenceMaximumKg": 77.33858267716536,
                            "currentPosition": "within",
                            "differenceFromRangeKg": 0,
                            "heightSourceScope": "within-five-foot-reference-basis",
                            "heightSourceScopeNote": "Boy, tarihsel formüllerin 5 fit (152,4 cm) başlangıç noktasındadır veya üzerindedir."
                        }
                    },
                    "tolerance": 1e-9
                },
                {
                    "caseId": "female-below-reference-range",
                    "scenario": "positive",
                    "input": {
                        "sex": "kadin",
                        "heightCm": 165,
                        "currentWeightKg": 50
                    },
                    "expected": {
                        "ok": true,
                        "value": {
                            "sex": "kadin",
                            "heightCm": 165,
                            "currentWeightKg": 50,
                            "devineKg": 56.90944881889762,
                            "robinsonKg": 57.43307086614172,
                            "hamwiKg": 56.413385826771645,
                            "referenceMinimumKg": 56.413385826771645,
                            "referenceMaximumKg": 57.43307086614172,
                            "currentPosition": "below",
                            "differenceFromRangeKg": 6.413385826771645,
                            "heightSourceScope": "within-five-foot-reference-basis",
                            "heightSourceScopeNote": "Boy, tarihsel formüllerin 5 fit (152,4 cm) başlangıç noktasındadır veya üzerindedir."
                        }
                    },
                    "tolerance": 1e-9
                },
                {
                    "caseId": "optional-current-weight-absent",
                    "scenario": "optional-input",
                    "input": {
                        "sex": "kadin",
                        "heightCm": 165
                    },
                    "expected": {
                        "ok": true,
                        "value": {
                            "sex": "kadin",
                            "heightCm": 165,
                            "currentWeightKg": null,
                            "devineKg": 56.90944881889762,
                            "robinsonKg": 57.43307086614172,
                            "hamwiKg": 56.413385826771645,
                            "referenceMinimumKg": 56.413385826771645,
                            "referenceMaximumKg": 57.43307086614172,
                            "currentPosition": null,
                            "differenceFromRangeKg": null,
                            "heightSourceScope": "within-five-foot-reference-basis",
                            "heightSourceScopeNote": "Boy, tarihsel formüllerin 5 fit (152,4 cm) başlangıç noktasındadır veya üzerindedir."
                        }
                    },
                    "tolerance": 1e-9
                },
                {
                    "caseId": "one-millimetre-below-five-foot",
                    "scenario": "extrapolation-threshold-below",
                    "input": {
                        "sex": "erkek",
                        "heightCm": 152.3,
                        "currentWeightKg": 50
                    },
                    "expected": {
                        "ok": true,
                        "value": {
                            "sex": "erkek",
                            "heightCm": 152.3,
                            "currentWeightKg": 50,
                            "devineKg": 49.909448818897644,
                            "robinsonKg": 51.925196850393704,
                            "hamwiKg": 47.89370078740158,
                            "referenceMinimumKg": 47.89370078740158,
                            "referenceMaximumKg": 51.925196850393704,
                            "currentPosition": "within",
                            "differenceFromRangeKg": 0,
                            "heightSourceScope": "below-five-foot-extrapolation",
                            "heightSourceScopeNote": "Boy, tarihsel formüllerin 5 fit (152,4 cm) başlangıç noktasının altındadır; sonuç geriye doğru ekstrapolasyondur."
                        }
                    },
                    "tolerance": 1e-9
                },
                {
                    "caseId": "exactly-five-foot",
                    "scenario": "extrapolation-threshold-at",
                    "input": {
                        "sex": "erkek",
                        "heightCm": 152.4,
                        "currentWeightKg": 50
                    },
                    "expected": {
                        "ok": true,
                        "value": {
                            "sex": "erkek",
                            "heightCm": 152.4,
                            "currentWeightKg": 50,
                            "devineKg": 50,
                            "robinsonKg": 52,
                            "hamwiKg": 48,
                            "referenceMinimumKg": 48,
                            "referenceMaximumKg": 52,
                            "currentPosition": "within",
                            "differenceFromRangeKg": 0,
                            "heightSourceScope": "within-five-foot-reference-basis",
                            "heightSourceScopeNote": "Boy, tarihsel formüllerin 5 fit (152,4 cm) başlangıç noktasındadır veya üzerindedir."
                        }
                    },
                    "tolerance": 1e-9
                },
                {
                    "caseId": "height-below-input-range",
                    "scenario": "adversarial",
                    "input": {
                        "sex": "erkek",
                        "heightCm": 139,
                        "currentWeightKg": 75
                    },
                    "expected": {
                        "ok": false,
                        "field": "heightCm",
                        "errorCode": "OUT_OF_RANGE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "height-above-input-range",
                    "scenario": "adversarial",
                    "input": {
                        "sex": "erkek",
                        "heightCm": 221,
                        "currentWeightKg": 75
                    },
                    "expected": {
                        "ok": false,
                        "field": "heightCm",
                        "errorCode": "OUT_OF_RANGE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "weight-below-input-range",
                    "scenario": "adversarial",
                    "input": {
                        "sex": "erkek",
                        "heightCm": 180,
                        "currentWeightKg": 29
                    },
                    "expected": {
                        "ok": false,
                        "field": "currentWeightKg",
                        "errorCode": "OUT_OF_RANGE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "weight-above-input-range",
                    "scenario": "adversarial",
                    "input": {
                        "sex": "erkek",
                        "heightCm": 180,
                        "currentWeightKg": 251
                    },
                    "expected": {
                        "ok": false,
                        "field": "currentWeightKg",
                        "errorCode": "OUT_OF_RANGE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "unsupported-sex",
                    "scenario": "adversarial",
                    "input": {
                        "sex": "diger",
                        "heightCm": 180,
                        "currentWeightKg": 75
                    },
                    "expected": {
                        "ok": false,
                        "field": "sex",
                        "errorCode": "UNSUPPORTED_VALUE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "numeric-string-weight",
                    "scenario": "adversarial",
                    "input": {
                        "sex": "erkek",
                        "heightCm": 180,
                        "currentWeightKg": "75"
                    },
                    "expected": {
                        "ok": false,
                        "field": "currentWeightKg",
                        "errorCode": "NOT_FINITE"
                    },
                    "tolerance": 0
                },
                {
                    "caseId": "source-url-mismatch",
                    "scenario": "adversarial",
                    "input": {
                        "sex": "erkek",
                        "heightCm": 180,
                        "currentWeightKg": 75
                    },
                    "configMutation": {
                        "path": [
                            "metadata",
                            "sources",
                            0,
                            "url"
                        ],
                        "replacement": "https://example.com/not-accepted"
                    },
                    "expected": {
                        "ok": false,
                        "field": "config.metadata.sources",
                        "errorCode": "INVALID_CONFIG"
                    },
                    "tolerance": 0
                }
            ]
        }
    ]
};
